export default {
  SALARYPERIOD_HOUR: 'per uur',
  SALARYPERIOD_WEEK: 'per week',
  SALARYPERIOD_MONTH: 'per maand',
  SALARYPERIOD_FOUR_WEEKS: 'per 4 weken',
  SALARYPERIOD_YEAR: 'per jaar'
}
